import React, { ComponentProps } from 'react';
import { Mentions, Tooltip } from 'antd';

import { useIntl } from 'common/config/i18n';

import { useFormKeywords } from './keywords-context';

interface DataDrivenOptionProps {
  label: string;
  value: string;
}

interface Props extends Omit<ComponentProps<typeof Mentions>, 'prefix'> {
  options: DataDrivenOptionProps[];
}
/**
 * The prefix is supposed to be "{{" but antdesign doesn't work well with a 2 character prefix
 * so the prefix is "{" but we add the second "{" directly in the value in order to send to the MDW "{{myVar}}"
 */
const PREFIX = '{';
const SUFFIX = '}}';

export const InputKeywords: React.FC<Props> = ({ options, ...props }) => {
  const { t } = useIntl();

  const mentionsOptions = options.map((option) => ({ value: `{${option.value}${SUFFIX}`, label: option.value }));

  return (
    <Tooltip title={t('keywords', 'tooltip')}>
      <Mentions prefix={PREFIX} options={mentionsOptions} {...props} />
    </Tooltip>
  );
};

export type InputKeywordsFetchedProps = Omit<ComponentProps<typeof InputKeywords>, 'options'>;

/**
 * displays some fetched keywords when the user type `{{`,
 * connected component (fetches keywords automatically),
 * used by <Input /> organism (withKeywords prop),
 * be careful of the onChange prop (not wrapped in a classic JS event)
 */
const InputKeywordsFetched: React.FC<InputKeywordsFetchedProps> = (props) => {
  const { keywords, loading } = useFormKeywords();

  const dataDrivenOptions: DataDrivenOptionProps[] = keywords.map((item) => ({
    label: item,
    value: item,
  }));

  return <InputKeywords {...props} options={dataDrivenOptions} loading={loading} />;
};

export default InputKeywordsFetched;
